/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCutlery = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h2v8h1V2h2v8h1V2h2v10a4.002 4.002 0 0 1-3 3.874V22H5v-6.126A4.002 4.002 0 0 1 2 12zm4 12a2 2 0 0 0 2-2H4a2 2 0 0 0 2 2zM17 2c-1.543 0-2.817.938-3.66 2.203C12.492 5.474 12 7.173 12 9c0 1.827.492 3.526 1.34 4.797.653.98 1.565 1.764 2.66 2.067V22h2v-6.136c1.095-.303 2.007-1.087 2.66-2.067C21.508 12.526 22 10.827 22 9c0-1.827-.492-3.526-1.34-4.797C19.817 2.938 18.543 2 17 2zm-3 7c0-1.487.404-2.788 1.004-3.688C15.608 4.405 16.334 4 17 4s1.392.405 1.996 1.312C19.596 6.212 20 7.513 20 9s-.404 2.788-1.004 3.688C18.392 13.595 17.666 14 17 14s-1.392-.405-1.996-1.312C14.404 11.788 14 10.487 14 9z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCutlery as Cutlery };
